@if (label()) {
  <label for="inputText" class="col-span-12 mb-1 text-sm font-medium">
    {{ label() }}
  </label>
}

<p-multi-select
  [placeholder]="placeholder()"
  [options]="options()"
  [optionLabel]="optionLabel()"
  (onChange)="onSelect($event)"
  (onBlur)="onBlur()"
  [filterBy]="filterBy()"
  size="small"
  emptyFilterMessage="Nenhum resultado encontrado"
  [fluid]="fluid()"
  [ngClass]="{ 'ng-invalid': showErrors, 'ng-dirty': showErrors }"
  selectedItemsLabel="{0} itens selecionados"
  (click)="$event.stopPropagation()"
  showClear
  (onClear)="onClear()"
  class="col-span-12"
  appendTo="body"
/>

<app-helper-text
  class="col-span-12"
  [errorMessage]="errorMessage"
  [showErrors]="showErrors"
  [helperText]="helperText()"
/>
